export const SNAKE_TO_CAMEL = (
  input: string,
  {
    pascal,
    spaced,
  }: {
    pascal?: boolean;
    spaced?: boolean;
  } = {}
): string =>
  input
    .split("_")
    .reduce(
      (res, word, i) =>
        (i === 0 && !pascal)
          ? word.toLowerCase()
          : `${res}${i > 0 && spaced ? ' ' : ''}${word.charAt(0).toUpperCase()}${word.substring(1).toLowerCase()}`,
      ''
    );
